import { render } from "./simple_keyboard.vue?vue&type=template&id=0d961655&scoped=true&ts=true"
import script from "./simple_keyboard.vue?vue&type=script&lang=ts"
export * from "./simple_keyboard.vue?vue&type=script&lang=ts"

import "./simple_keyboard.vue?vue&type=style&index=0&id=0d961655&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d961655"]])

export default __exports__